import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "../data/site";
import { Brand } from "./Brand";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 bg-ofc-black border-b ${
        scrolled || open ? "border-white/10" : "border-white/5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <Brand />

          <nav className="hidden lg:flex items-center gap-10" data-testid="desktop-nav">
            {NAV.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                data-testid={`nav-${item.path === "/" ? "inici" : item.path.replace("/", "")}`}
                className={({ isActive }) =>
                  `text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${
                    isActive ? "text-ofc-gold" : "text-white/70 hover:text-white"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contacte"
              data-testid="header-cta"
              className="border border-ofc-gold text-ofc-gold px-6 py-2.5 text-xs uppercase tracking-[0.2em] hover:bg-ofc-gold hover:text-ofc-black transition-colors duration-300"
            >
              Sol·licitar consulta
            </Link>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-white p-2"
            aria-label="Menú"
          >
            {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-ofc-black/95 backdrop-blur-xl border-t border-white/5" data-testid="mobile-nav">
          <nav className="flex flex-col px-6 py-6 gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                data-testid={`mobile-nav-${item.path === "/" ? "inici" : item.path.replace("/", "")}`}
                className={({ isActive }) =>
                  `py-3 text-sm uppercase tracking-[0.2em] border-b border-white/5 ${
                    isActive ? "text-ofc-gold" : "text-white/80"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contacte"
              className="mt-4 text-center border border-ofc-gold text-ofc-gold px-6 py-3 text-xs uppercase tracking-[0.2em]"
            >
              Sol·licitar consulta
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};
